import React from 'react';
import styles from '../assets/css/module/common.module.css';

const AttendancePIK = () => {
  return (
    <div className={`${styles['default-layout']}`}>
      404
    </div>
  );
}

export default AttendancePIK;